const isObj = require('lodash.get');

export const getCmsLists = (state) => isObj(state, 'cmsLists', []);
export const getCmslistdetailsById = (state) => isObj(state, 'cmslistdetailsById', []);
